import type { HiredEquipmentRowAttachment } from '../types';

export const HE_ATTACHMENT_ACCEPT =
  'image/jpeg,image/png,image/webp,image/gif,image/bmp,application/pdf';

const ALLOWED_TYPES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/bmp',
  'application/pdf',
]);

const ALLOWED_EXT = /\.(jpe?g|png|gif|bmp|webp|pdf)$/i;

export function isAllowedHiredEquipmentAttachment(file: File): boolean {
  if (ALLOWED_TYPES.has(file.type.toLowerCase())) return true;
  return ALLOWED_EXT.test(file.name);
}

export function attachmentFromDto(dto: HiredEquipmentRowAttachment): HiredEquipmentRowAttachment {
  return {
    filename: dto.filename,
    contentType: dto.contentType,
    size: dto.size,
    url: dto.url,
    key: dto.key,
  };
}
